import { Link, useNavigate } from "react-router-dom";
import { WorldMap } from "./WorldMap";
import GoogleStreetView from "./GoogleStreetView";
import { useGameContext } from "../context/useGameContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { formatCurrency } from "../utilities/formatCurrency";
import { useEffect } from "react";

// Polska odmiana rzeczownika w zależności od liczby (1 / 2-4 / 5+)
const pluralize = (n: number, one: string, few: string, many: string) => {
  if (n === 1) return one;
  const lastDigit = n % 10;
  const lastTwo = n % 100;
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwo < 12 || lastTwo > 14)) {
    return few;
  }
  return many;
};

export const GamePage = () => {
  const { markers, cartValue, isGameRunning, isGameStatusLoading } =
    useGameContext();

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0); // Przewija do góry strony
  }, []);

  useEffect(() => {
    if (!isGameStatusLoading && !isGameRunning) {
      navigate("/");
    }
  }, [isGameRunning, isGameStatusLoading, navigate]);

  return (
    <section className="hero">
      <div>
        <div className="heroGame">
          <GoogleStreetView />
        </div>
        <div>
          <WorldMap />
        </div>
      </div>
      <br />
      <div className="game-buttons">
        <Link to="/cart">
          <button
            className={`button is-primary is-fullwidth is-medium
            ${markers.length <= 0 ? "is-disabled" : ""}`}
            disabled={markers.length <= 0}
          >
            <span className="icon is-small">
              <FontAwesomeIcon icon={faCheck} />
            </span>
            <span>Wyślij odpowiedzi</span>
          </button>
        </Link>
        <button className="button is-fullwidth is-medium">
          <p className="">Wartość koszyka: {formatCurrency(cartValue)}</p>
        </button>
      </div>
      {markers.length > 0 && (
        <p className="mascot-live-counter">
          🐾 {markers.length}{" "}
          {pluralize(markers.length, "znacznik", "znaczniki", "znaczników")} ={" "}
          {markers.length}{" "}
          {pluralize(markers.length, "maskotka", "maskotki", "maskotek")} do
          odebrania —{" "}
          <Link to="/maskotki">zobacz pełną serię</Link>
        </p>
      )}
    </section>
  );
};
